












import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import IdDocType from '@/resources/enum/IdDocType';

@Component
export default class TopContentSelect extends Vue {
  @Prop({ type: Array, required: true })
  public list!: {
    key: IdDocType;
    text: string;
  }[];

  @Prop({ type: Number, required: true })
  public value!: IdDocType;

  @Emit()
  public input(value: IdDocType) {}

  private get localValue(): IdDocType {
    return this.value;
  }

  private set localValue(value: IdDocType) {
    this.input(value);
  }
}
